export default {
  getHead: () => {
    return [{ name: "종사자 부서명" }, { name: "ID(사번)" }, { name: "종사자 성명" }, { name: "종사자 부서" }, { name: "구분" }, { name: "직종" }, { name: "작성자" }, { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).inputA_0;
        case 1:
          return func.getContent(value).inputA_1;
        case 2:
          return func.getContent(value).inputA_7;
        case 3:
          return func.getContent(value).inputA_3;
        case 4:
          return func.getContent(value).inputA_4;
        case 5:
          return func.getContent(value).inputB_7;
        case 6:
          return value.user ? value.user.name : value.author.name; // 작성자
        case 7:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];
    switch (nav.value.searchType) {
      case "종사자 부서명":
        returnData.push("content$body.inputA_0*%[:default_skw]%");
        break;
      case "ID(사번)":
        returnData.push("content$body.inputA_1*%[:default_skw]%");
        break;
      case "종사자 성명":
        returnData.push("content$body.inputA_7*%[:default_skw]%");
        break;
      case "종사자 팀명":
        returnData.push("content$body.inputA_3*%[:default_skw]%");
        break;
      case "구분":
        returnData.push("content$body.inputA_4*%[:default_skw]%");
        break;
      case "직종":
        returnData.push("content$body.inputB_7*%[:default_skw]%");
        break;
    }
    return returnData;
  },
};
